module.exports = __webpack_public_path__ + "img/bus_stop.a0f27f60.jpg";